import { render, staticRenderFns } from "./churuLy.vue?vue&type=template&id=0278eb80&scoped=true"
import script from "./churuLy.vue?vue&type=script&lang=js"
export * from "./churuLy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278eb80",
  null
  
)

export default component.exports